import { useMutation } from 'react-query';
import { deleteComment, deletePrivateComment } from '../Services/Api';

export default ({ discussionType, postId, commentId }: any) => {
  if (discussionType) {
    const { mutate, ...rest } = useMutation(() => deletePrivateComment(commentId), {
      useErrorBoundary: true,
    });

    return { destroy: mutate, ...rest };
  }
  const { mutate, ...rest } = useMutation(() => deleteComment(postId, commentId), {
    useErrorBoundary: true,
  });

  return { destroy: mutate, ...rest };
};
